import { CartesianChart } from "./CartesianChart";
import type {
  ChartInteraction,
  ChartMask,
  ChartVariant,
  MixedChartSpec,
} from "./types";

/** Overlay chart: each series renders as its own `bar` or `line`. */
export function MixedChart({
  spec,
  variant,
  mask,
  ...interaction
}: {
  spec: MixedChartSpec;
  variant: ChartVariant;
  mask?: ChartMask;
} & ChartInteraction) {
  return <CartesianChart spec={spec} variant={variant} mask={mask} {...interaction} />;
}
